import {UtmService} from 'app/features/sign-up/services/utm.service';

function collectUtmFromUrl(): Record<string, string> {
    return window.location.search
        .slice(1)
        .split('&')
        .reduce((acc, elm) => {
            if (elm === '') {
                return acc;
            }
            let spl = elm.split('=');
            if (spl[0].startsWith('utm') && spl[1]) {
                acc[spl[0]] = decodeURIComponent(spl[1]);
            }
            return acc;
        }, {});
}

export function utmTagsInitializerFactory(service: UtmService) {
    return async () => {
        const utm = collectUtmFromUrl();
        // save only if we have some new utm tags in url
        if (Object.keys(utm).length) {
            service.setUtmLocalStorage(utm);
        }
    };
}
